import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import { Grid, TextField, Button, makeStyles, IconButton, Typography } from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { Cancel } from '@material-ui/icons';
import moment from 'moment';
import PropTypes from 'prop-types';
import { AppBar } from '@material-ui/core';
import { Tabs, Switch, FormControlLabel } from '@material-ui/core';
import { Tab } from '@material-ui/core';
import { Box } from '@material-ui/core';

import { searchItems } from '../api';
import Image from '../../Moderation/partials/Image';

const MAX_CHALLENGE_ITEMS_NUMBER = 20;

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box p={3}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
}

export const ChallengeForm = ({ challenge, merchantId, onClose, onBackdropUpdate }) => {
	const [key, setKey] = React.useState('');
	const [showError, setShowError] = React.useState(false);
	const [items, setItems] = React.useState([]);
	const [selectedItems, setSelectedItems] = React.useState(challenge?.items || []);
	const [value, setValue] = React.useState(0);

	const handleTabChange = (event, newValue) => {
		setValue(newValue);
	};

	if (challenge) {
		merchantId = challenge.merchantId;
	}
	const formik = useFormik({
		isInitialValid: true,
		initialValues: {
			title: challenge?.title || '',
			body: challenge?.body || '',
			button: challenge?.button || '',
			image: challenge?.image || '',
			from: challenge?.from || moment().format('MM/DD/YYYY'),
			to:
				challenge?.to ||
				moment()
					.add(6, 'month')
					.format('MM/DD/YYYY'),
			wizardText1: challenge?.wizardText1 || '',
			wizardText2: challenge?.wizardText2 || '',
			placeHolder: challenge?.placeHolder || '',
			couponCode: challenge?.couponCode || '',
			websiteLink: challenge?.websiteLink || '',
			postMessageTitle: challenge?.postMessageTitle || '',
			postMessageDescription: challenge?.postMessageDescription || '',
			postMessageImage: challenge?.postMessageImage || '',
			postMessageBackgroundImage: challenge?.postMessageBackgroundImage || '',
			postMessageButton: challenge?.postMessageButton || '',
			legalTerms: challenge?.legalTerms || '',
			hashtag: challenge?.hashtag || '#',
			acceptGuest: challenge?.acceptGuest || true,
			minItems: challenge?.minItems || 2,
			maxItems: challenge?.maxItems || 4,
		},
		validate: v => {
			const err = {};

			for (const field of [
				'title',
				'body',
				'button',
				'image',
				'from',
				'to',
				'wizardText1',
				'postMessageTitle',
				'postMessageDescription',
				'postMessageImage',
				'postMessageButton',
				'minItems',
				'maxItems',
			]) {
				if (!v[field]) {
					err[field] = 'Required';
				}
			}

			if (v.minItems > v.maxItems) {
				err.minItems = "Min number shouldn't be bigger than max number";
			}

			if (v.maxItems < v.minItems) {
				err.maxItems = "Max number shouldn't be less than max number";
			}

			if (v.minItems < 1) {
				err.maxItems = "Min number shouldn't be less than 1";
			}

			if (v.maxItems > 4) {
				err.maxItems = "Max number shouldn't be bigger than 4";
			}

			if (Object.keys(err).length) {
				setShowError(true);
			} else {
				setShowError(false);
			}
			return err;
		},
	});
	const classes = useStyles();

	const fetchItems = value => {
		if (value) {
			searchItems({ merchantId, key: value || key }).then(res => {
				const selectedIdsMap = {}
				selectedItems.forEach((item) => {
					selectedIdsMap[item._id] = true
				})
				res.forEach(i1 => {
					i1.selected = selectedIdsMap[i1._id];
				});
				setItems(res);
			});
		} else {
			selectedItems.forEach(item => item.selected = true)
			setItems(selectedItems)
		}
	};

	const handleSearchItem = value => {
		setKey(value);
		fetchItems(value);
	};

	const toggleItemSelection = (item, select) => {
		const index = selectedItems.findIndex(i => i._id === item._id);

		if (select) {
			if (selectedItems.length === MAX_CHALLENGE_ITEMS_NUMBER || index > -1) {
				return;
			}
			selectedItems.push(item);
		} else {
			selectedItems.splice(index, 1);
		}
		items.forEach(i1 => {
			i1.selected = !!selectedItems.find(i2 => i1._id === i2._id);
		});
		setSelectedItems([...selectedItems]);
		setItems([...items]);
	};

	const handleSave = () => {
		onClose({ ...formik.values, items: selectedItems });
	};
	const { values, handleChange, handleBlur, touched, errors, setFieldValue } = formik;

	React.useEffect(fetchItems, []);
	useEffect(() => {
		if (onBackdropUpdate) {
			handleSave()
		}
	})

	return (
		<>
			<div className={classes.root}>
				<AppBar color="light" position="static">
					<Tabs value={value} variant="fullWidth" onChange={handleTabChange} aria-label="simple tabs example">
						<Tab label="General" {...a11yProps(0)} />
						<Tab label="Description" {...a11yProps(1)} />
						<Tab label="Items" {...a11yProps(2)} />
						<Tab label="Post Message" {...a11yProps(3)} />
					</Tabs>
				</AppBar>
				<TabPanel value={value} index={0}>
					<Grid container>
						<Grid item style={{ marginRight: 24 }}>
							<form>
								<TextField
									name='title'
									className={classes.field}
									value={values.title}
									onChange={handleChange}
									onBlur={handleBlur}
									label='Title'
									size='medium'
									helperText={touched.title ? errors.title : ''}
									fullWidth
									required
									error={errors.title && touched.title}
								/>
								<TextField
									name='body'
									value={values.body}
									onChange={handleChange}
									onBlur={handleBlur}
									className={classes.field}
									label='Body'
									size='medium'
									error={errors.body && touched.body}
									helperText={touched.body ? errors.body : ''}
									fullWidth
									multiline
									required
								/>
								<TextField
									name='image'
									value={values.image}
									onChange={handleChange}
									onBlur={handleBlur}
									className={classes.field}
									label='Image URL'
									size='medium'
									helperText={touched.image ? errors.image : ''}
									error={errors.image && touched.image}
									fullWidth
									required
								/>
								<TextField
									name='button'
									value={values.button}
									onChange={handleChange}
									onBlur={handleBlur}
									className={classes.field}
									label='Button'
									size='medium'
									error={errors.button && touched.button}
									helperText={touched.button ? errors.button : ''}
									fullWidth
									required
								/>


								<MuiPickersUtilsProvider utils={DateFnsUtils}>
									<KeyboardDatePicker
										name='from'
										disableToolbar
										variant='inline'
										format='MM/dd/yyyy'
										label='From'
										value={values.from}
										onChange={value => setFieldValue('from', value)}
										onBlur={handleBlur}
										required
										helperText={touched.from ? errors.from : ''}
										error={errors.from && touched.from}
										style={{ marginRight: 12, width: `calc(50% - 6px)` }}
									/>
									<KeyboardDatePicker
										name='to'
										disableToolbar
										variant='inline'
										format='MM/dd/yyyy'
										label='To'
										value={values.to}
										onChange={value => setFieldValue('to', value)}
										onBlur={handleBlur}
										required
										helperText={touched.to ? errors.to : ''}
										error={errors.to && touched.to}
										style={{ width: `calc(50% - 6px)` }}
									/>
								</MuiPickersUtilsProvider>
								<TextField
									name='legalTerms'
									className={classes.field}
									value={values.legalTerms}
									onChange={handleChange}
									onBlur={handleBlur}
									label='Legal Terms'
									size='medium'
									helperText={touched.postMessageButton ? errors.postMessageButton : ''}
									fullWidth
								/>
								<TextField
									name='hashtag'
									className={classes.field}
									value={values.hashtag}
									onChange={(e) => {
										if (e.target.value && e.target.value.startsWith('#')) {
											handleChange(e)
										} else if (!e.target.value) {
											e.target.value = '#'
											handleChange(e)
										}
									}}
									onBlur={handleBlur}
									label='#Tag'
									size='medium'
									helperText={touched.postMessageButton ? errors.postMessageButton : ''}
									fullWidth
								/>
								<FormControlLabel control={<Switch
									defaultChecked
									name='acceptGuest'
									onChange={handleChange}
									value={values.acceptGuest} />} label="Allow guest to participate" />
							</form>
						</Grid>
					</Grid>
				</TabPanel>
				<TabPanel value={value} index={1}>
					<TextField
						name='wizardText1'
						className={classes.field}
						value={values.wizardText1}
						onChange={handleChange}
						onBlur={handleBlur}
						label='Wizard Text 1'
						size='medium'
						helperText={touched.wizardText1 ? errors.wizardText1 : ''}
						fullWidth
						required
						error={errors.wizardText1 && touched.wizardText1}
					/>
					<TextField
						name='placeHolder'
						className={classes.field}
						value={values.placeHolder}
						onChange={handleChange}
						onBlur={handleBlur}
						label='Placeholder'
						size='medium'
						helperText={touched.placeHolder ? errors.placeHolder : ''}
						fullWidth
						required
						error={errors.placeHolder && touched.placeHolder}
					/>
					<TextField
						name='wizardText2'
						className={classes.field}
						value={values.wizardText2}
						onChange={handleChange}
						onBlur={handleBlur}
						label='Wizard Text 2, optional'
						size='medium'
						helperText={touched.wizardText2 ? errors.wizardText2 : ''}
						fullWidth
						multiline
						rows={6}
						error={errors.wizardText2 && touched.wizardText2}
					/>
					<TextField
						name='postMessageBackgroundImage'
						className={classes.field}
						value={values.postMessageBackgroundImage}
						onChange={handleChange}
						onBlur={handleBlur}
						label='Text Challenge Background Image, optional'
						size='medium'
						helperText={touched.postMessageBackgroundImage ? errors.postMessageBackgroundImage : ''}
						fullWidth
						error={errors.postMessageBackgroundImage && touched.postMessageBackgroundImage}
					/>
				</TabPanel>
				<TabPanel value={value} index={2}>
					<Grid className={classes.field}>
						<TextField
							style={{ marginRight: 12, width: `calc(50% - 6px)` }}
							name='minItems'
							type='number'
							value={values.minItems}
							inputProps={{
								min: 1,
								max: values.maxItems,
							}}
							onChange={handleChange}
							onBlur={handleBlur}
							label='Min'
							size='medium'
							disabled={selectedItems < 1}
							helperText={touched.minItems ? errors.minItems : ''}
							fullWidth
							required
							error={errors.minItems && touched.minItems}
						/>
						<TextField
							style={{ width: `calc(50% - 6px)` }}
							name='maxItems'
							type='number'
							value={values.maxItems}
							inputProps={{
								min: values.minItems,
								max: 4,
							}}
							onChange={handleChange}
							onBlur={handleBlur}
							label='Max'
							size='medium'
							disabled={selectedItems < 1}
							helperText={touched.maxItems ? errors.maxItems : ''}
							fullWidth
							required
							error={errors.maxItems && touched.maxItems}
						/>
					</Grid>
					{selectedItems.length >= 1 && (
						<Grid container>
							<Typography variant='subtitle1'>
								Select up to 20 items
							</Typography>
						</Grid>
					)}
					<Grid>
						<TextField
							value={key}
							onChange={e => handleSearchItem(e.target.value)}
							label='Search items'
							style={{ width: 400 }}
						/>
						<Grid container className={classes.itemsContainer}>
							{items.map(item => (
								<Grid className={classes.item} key={item._id}>
									<Image
										width='100px'
										height='120px'
										src={item.img}
										onClick={() => toggleItemSelection(item, true)}
									/>
									{item.selected && (
										<IconButton
											className={classes.selected}
											onClick={() => toggleItemSelection(item, false)}
										>
											<Cancel color='secondary' />
										</IconButton>
									)}
								</Grid>
							))}
						</Grid>
					</Grid>
				</TabPanel>
				<TabPanel value={value} index={3}>
					<form>
						<TextField
							name='postMessageTitle'
							className={classes.field}
							value={values.postMessageTitle}
							onChange={handleChange}
							onBlur={handleBlur}
							label='Post Message Title'
							size='medium'
							helperText={touched.postMessageTitle ? errors.postMessageTitle : ''}
							fullWidth
							required
							error={errors.postMessageTitle && touched.postMessageTitle}
						/>
						<TextField
							name='postMessageDescription'
							className={classes.field}
							value={values.postMessageDescription}
							onChange={handleChange}
							onBlur={handleBlur}
							label='Post Message Description'
							size='medium'
							helperText={touched.postMessageDescription ? errors.postMessageDescription : ''}
							fullWidth
							required
							error={errors.postMessageDescription && touched.postMessageDescription}
						/>
						<TextField
							name='couponCode'
							className={classes.field}
							value={values.couponCode}
							onChange={handleChange}
							onBlur={handleBlur}
							label='Coupon Code, Optional'
							size='medium'
							fullWidth
						/>
						<TextField
							name='postMessageImage'
							className={classes.field}
							value={values.postMessageImage}
							onChange={handleChange}
							onBlur={handleBlur}
							label='Post Message Image'
							size='medium'
							helperText={touched.postMessageImage ? errors.postMessageImage : ''}
							fullWidth
							required
							error={errors.postMessageImage && touched.postMessageImage}
						/>

						<TextField
							name='postMessageButton'
							className={classes.field}
							value={values.postMessageButton}
							onChange={handleChange}
							onBlur={handleBlur}
							label='Post Message Button'
							size='medium'
							helperText={touched.postMessageButton ? errors.postMessageButton : ''}
							fullWidth
							required
							error={errors.postMessageButton && touched.postMessageButton}
						/>
						<TextField
							name='websiteLink'
							className={classes.field}
							value={values.websiteLink}
							onChange={handleChange}
							onBlur={handleBlur}
							label='Button Link, Optional'
							size='medium'
							fullWidth
						/>
					</form>
				</TabPanel>
			</div>

			<Grid container justify='flex-end' spacing={2} style={{ marginTop: 24 }}>
				<Grid item>
					<Button onClick={() => onClose()}>Cancel</Button>
				</Grid>
				<Grid item>
					<Button
						variant='contained'
						color='secondary'
						disabled={showError || !formik.isValid}
						onClick={() => handleSave()}
					>
						{challenge ? 'Update' : 'Create'}
					</Button>
				</Grid>
			</Grid>
		</>
	);
};

const useStyles = makeStyles(() => ({
	field: {
		marginBottom: 6,
		width: 510,
		display: 'block',
	},
	itemsContainer: {
		marginTop: 12,
		width: 426,
		overflowY: 'auto',
		overflowX: 'hidden',
	},
	selectedItems: {
		maxWidth: 510,
		marginTop: 12,
	},
	item: {
		marginBottom: 2,
		marginRight: 2,
		cursor: 'pointer',
		position: 'relative',
		transition: 'opacity linear 0.2s',
		opacity: 1,
		'&:hover': {
			opacity: 0.8,
		},
	},
	selected: {
		position: 'absolute',
		top: -12,
		right: -12,
	},
}));
